
import constantes from '../resources/constantes.json';

export function getCandidatosImg(nomenclator,codcan,codparPostition) {
    if (codcan) {
      const basename = `${constantes.rutas.candidatos}${codcan.padStart(3, '0')}-${nomenclator.partidos[Number(codparPostition) - 1].codpar.padStart(4, '0')}`;
      return { imgPresi: basename + '-P', imgVice: basename + '-V' }
    } else {
      return { mgPresi: '', imgVice: '' }
    }
  }